// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__FxSya","loaderOuter":"PageOverlayLoader_loaderOuter__1QdF8"};